$(function() {
  var duration = 500;
  var duration2 = 500;

  var current_scrollY_start = $(window).scrollTop();

  function preSetScript(){

    function stringToPrice(){
      $.each($('article').find('.func-digit'), function(index) {
        var number = $(this).text().replace(',', '');
        var price = Number(number).toLocaleString();
        /*console.log('index:' + index + '/' + price);*/
        $(this).html(price);
      });
    }

    stringToPrice();

    // スクロール + ウィンドウサイズ系の対策処理
    function scrollAnimationSet(target) {
      const scButtonWrap = $('#scrollTopWrap');
      const fixedButton = $('#fixedButton');
      const header = $('#fixedHeader');
      const position = document.documentElement;
      let pageHeight;
      let wHeight = window.innerHeight;
      let preSetWidth = window.innerWidth;
      let scrollCount = 0;

      function setHeightProperty() {
        wHeight = window.innerHeight;
        pageHeight = $('body').innerHeight();
        position.style.setProperty('--wHeight', window.innerHeight);
        position.style.setProperty('--wHeightPx', window.innerHeight + 'px');
        position.style.setProperty('--scroll', window.scrollY);
        if(window.scrollY > 100){
          header.addClass('rolled');
        }else{
          header.removeClass('rolled');
        }
        if (document.getElementById('bgWhite')) {
          var imgPos = $('#bgWhite').offset().top;
          var windowHeight = $(window).height();
          if (document.getElementById('whiteHeader')) {
            if(window.scrollY > imgPos - windowHeight + windowHeight / 10){
              header.removeClass('white');
            }else{
              header.addClass('white');
            }
          }
          if(window.scrollY > imgPos  - windowHeight + windowHeight / 5 ){
            $('article').removeClass('black');
            $('#bgWhite').removeClass('effect');
          }else{
            $('article').addClass('black');
            $('#bgWhite').addClass('effect');
          }
        }
        /*$(".func-scroll-animation").each(function() {
          var imgPos = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll > imgPos - windowHeight + windowHeight / 4) {
            $(this).removeClass('effect');
          }
        });*/
        requestAnimationFrame(setProperties);
      }

      function setProperties() {
        setHeightProperty();
      }

      function init() {
        var timer = false;
        setProperties();
        position.style.setProperty('--wHeightFixedPx', window.innerHeight + 'px');
      }

      init();

    }

    scrollAnimationSet($('article'));


    // ハンバーガーメニューの開閉
    function humMenuControll(target) {
      var header = $('header');
      var humMenuState = 0;
      var humButton = $('#humButton');
      var humClose = $('#humClose');
      var humCloseButton = $('#humCloseButton');
      var fadeBox = [];

      function hummenuOpen() {
        console.log('humMenuState:' + humMenuState);
        if(humMenuState == 0){
          target.addClass('open');
          header.addClass('hum_open');
          humMenuState = 1;
        }else{
          target.removeClass('open');
          header.removeClass('hum_open');
          humMenuState = 0;
        }
      }


      function init() {
        humButton.on({
          'click': function() {
            hummenuOpen();
          }
        });
      }

      init();
    }

    humMenuControll($('#hummenu'));


    //コースレイアウトの切り替えボタン
    function workWrapShifter(target){
      var workWrapBox = $('#workWrapBox');
      shifterButton = [];
      targetSection = [];

      function changeWorkWrap(e){
        var contentHeight = $(targetSection[e]).outerHeight();
        workWrapBox.find('.work-section').removeClass('display');
        $(targetSection[e]).addClass('display');
        workWrapBox.css({'height': contentHeight + 'px'});
        target.find('button').removeClass('active_button');
        shifterButton[e].addClass('active_button');
      }

      function init(){
        $.each(target.find('button'), function(index) {
          shifterButton[index] = $(this);
          targetSection[index] = $(this).attr("jump");
          shifterButton[index].on({
            'click': function() {
              changeWorkWrap(index);
            }
          });
        });

        changeWorkWrap(0);

      }

      init();

    }

    if (document.getElementById('workShifter')) {
      workWrapShifter($('#workShifter'));
    }

    //クリエイター詳細 紹介文のレイアウト
    function creatorDescOpen(target){
      var descInner = $('#descInner');
      var profileView = $('#profileView');

      function init(){
        profileView.on({
          'click': function() {
            var targetHeight = descInner.innerHeight();
            target.addClass('open').css({'height': targetHeight + 'px'});
          }
        });
      }

      init();

    }

    if (document.getElementById('profileDesc')) {
        creatorDescOpen($('#profileDesc'));
    }

    // クリエイタープロフィール詳細ポップアップ
    function creatorProfilePop(target){
      var profileDisplay = $('#profileDisplay');
      var profileBg = $('#profileBg');
      var profileClose = $('#profileClose');

      function init(){
        profileDisplay.on({
          'click': function() {
            target.addClass('open');
          }
        });
        profileBg.on({
          'click': function() {
            target.removeClass('open');
          }
        });
        profileClose.on({
          'click': function() {
            target.removeClass('open');
          }
        });
      }

      init();

    }

    if (document.getElementById('profilePop')) {
      creatorProfilePop($('#profilePop'));
    }

    // 作品詳細ポップアップ
    function workDetailDisplay(target){
      var creatorCollection = $('#creatorCollection');
      var workDetailBg = $('#workDetailBg');
      var workDetailClose = $('#workDetailClose');
      var popUpImg = $('#popUpImg');
      var imgDescription = $('#imgDescription');
      var workSamples = [];
      var workSrc = [];
      var workAlt = [];
      var popState = -1;
      var slideNext = $('#slideNext');
      var slidePrev = $('#slidePrev');
      var imgLength;

      function displayDetailPop(e){
        popUpImg.attr('src', workSrc[e]);
        var imgDesc = workAlt[e].split(',');
        imgDescription.html('');
        for (let i = 0; i < imgDesc.length; i++) {
          console.log('i:' + i);
          imgDescription.append('<li>' + imgDesc[i] + '</li>');
        }
        target.addClass('open');
        setTimeout(function() {
          target.removeClass('loading');
        }, 300);
      }

      function init(){
        console.log('#creatorCollection');
        $.each(creatorCollection.find('img:not(.spacer) '), function(index) {
          imgLength = index;
          workSrc[index] = $(this).attr('src');
          workAlt[index] = $(this).attr("alt");
          $(this).on({
            'click': function() {
              console.log('src:' + workSrc[index]);
              displayDetailPop(index);
              popState = index;
            }
          });
        });

        slideNext.on({
          'click': function() {
            target.addClass('loading');
            setTimeout(function() {
              if(popState != imgLength){
                popState = Number(popState) + Number(1);
              }else{
                popState = 0;
              }
              displayDetailPop(popState);
            }, 150);
          }
        });

        slidePrev.on({
          'click': function() {
            target.addClass('loading');
            setTimeout(function() {
              if(popState != 0){
                popState = Number(popState) - Number(1);
              }else{
                popState = imgLength;
              }
              displayDetailPop(popState);
            }, 150);
          }
        });

        workDetailBg.on({
          'click': function() {
            target.removeClass('open');
            popState = -1;
            setTimeout(function() {
              target.addClass('loading');
            }, 500);
          }
        });

        workDetailClose.on({
          'click': function() {
            target.removeClass('open');
            popState = -1;
            setTimeout(function() {
              target.addClass('loading');
            }, 500);
          }
        });

      }

      init();
    }

    if (document.getElementById('workDetailPop')) {
      workDetailDisplay($('#workDetailPop'));
    }

    // 商品詳細ページ サムネイルのスイッチ
    function thumbSwitcher(target){
      let thumbButton = [];
      let thumbSrc = [];
      let thumbSrcSet = [];
      let thumbBox = $('#thumbBox');
      let thumbImage = thumbBox.find('img');
      const time = 300;

      function switchImage(num){
        thumbBox.stop().animate({ opacity: 0 }, time, function() {
            thumbImage.attr('src', thumbSrc[num]);
            thumbImage.attr('srcset', thumbSrcSet[num]);
            $('.active_thumb').removeClass('active_thumb');
            thumbButton[num].addClass('active_thumb');
            thumbBox.stop().animate({ opacity: 1 }, time);
        });
      }

      function thumbHeightControll(){
        var thumbHeight = thumbImage.outerHeight();
        $('#thumnails').css({'max-height': thumbHeight + 'px'});
      }

      function init(){
        thumbHeightControll();
        $.each(target.find('button'), function(index) {
          thumbButton[index] = $(this);
          thumbSrc[index] = $(this).find('img').attr("src");
          thumbSrcSet[index] = $(this).find('img').attr("srcset");
          thumbButton[index].on({
            'click': function() {
              switchImage(index);
            }
          });
        });
        $(window).on({
          'resize': function(){
            thumbHeightControll();
          }
        });
      }

      init();

    }

    if (document.getElementById('workDetail')) {
      thumbSwitcher($('#thumnails'));
    }

    // 商品詳細ページ 蛇腹式レイアウト
    function toggleControl(target){
      let toggleItem = [];
      let toggleButton = [];
      let toggleContents = [];
      let toggleInner = [];
      let toggleType = [];
      let toggleState = [];
      let toggleState2 = [];
      let toggleInToggle = [];
      let windowWidth;
      let spWidth = 721;


      function toggleMove(e) {
        var buttonHeight = toggleButton[e].outerHeight();
        var tagetHeight = toggleContents[e].outerHeight();
        if (toggleState[e] == -1 || toggleState[e] == 0) {
          toggleButton[e].addClass('open');
          toggleItem[e].css({
            'height': buttonHeight + tagetHeight + 'px'
          });
          toggleState[e] = 1;
        } else {
          toggleButton[e].removeClass('open');
          var toggleHeight = toggleButton[e].outerHeight();
            toggleItem[e].css({
              'height': toggleHeight + 'px'
            });
          toggleState[e] = 0;
        }
      }

      function init(){
        windowWidth = $(window).width();
        $.each(target.find('.toggle_item'), function(index) {
          toggleItem[index] = $(this);
          toggleButton[index] = $(this).find('.toggle_button');
          toggleContents[index] = $(this).find('.toggle_contents');
          toggleInner[index] = $(this).find('.contents_inner');
          var tagetHeight = toggleInner[index].outerHeight();
          toggleState[index] = 0;

          toggleButton[index].on({
            'click': function() {
              toggleMove(index);
            }
          });

        });
      }

      init();

    }

    if (document.getElementById('workDetail')) {
      toggleControl($('#detailToggles'));
    }

    // インタビュー動画のポップアップ
    function interviewPopDisplay(target){
      var movieButton = [];
      var movieID = [];
      var interviewPop = $('#interviewPop');
      var interviewPopClose = $('#interviewPopClose');
      var movieFrame = $('#movieFrame');

      function moviePopOpen(e){
        interviewPop.addClass('loading');
        movieFrame.attr('src','https://player.vimeo.com/video/' + movieID[e] + '?title=0&amp;byline=0&amp;portrait=0&amp;app_id=122963');
        setTimeout(function() {
          interviewPop.addClass('open');
        }, 150);
        setTimeout(function() {
          interviewPop.removeClass('loading');
        }, 1000);
      }

      function init(){
        $.each(target.find('button'), function(index) {
          movieButton[index] = $(this);
          movieID[index] = $(this).attr("movieid");
          movieButton[index].on({
            'click': function() {
              moviePopOpen(index);
            }
          });
        });

        interviewPopClose.on({
          'click': function() {
            interviewPop.removeClass('open');
          }
        });
      }

      init();

    }

    if (document.getElementById('interviewList')) {
      interviewPopDisplay($('#interviewList'));
    }


    function contactPopDisplay(target){
      var messagePopOpen = $('#messagePopOpen');
      var contactPopClose = $('#contactPopClose');

      function init(){
        messagePopOpen.on({
          'click': function() {
            target.addClass('open');
          }
        });

        contactPopClose.on({
          'click': function() {
            target.removeClass('open');
          }
        });

      }

      init();

    }


    if (document.getElementById('contactPop')) {
      contactPopDisplay($('#contactPop'));
    }

  }

  preSetScript();

});
